import { useDispatch, useSelector } from 'react-redux'
import { IRedux } from 'store/ducks'
import Creators from 'store/ducks/app'

const useApp = () => {
  const dispatch = useDispatch()
  // ### TITLE PAGES
  const titlePage = useSelector((state: IRedux) => state.app.titlePage)
  const setTitlePage = (newValue: string | null) =>
    dispatch(Creators.titlePage(newValue))
  return { setTitlePage, titlePage }
}

export default useApp
